
document.addEventListener("DOMContentLoaded", function () {
  function waitForElement(selector, callback, timeout = 10000) {
    const el = document.querySelector(selector);
    if (el) return callback(el);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(() => observer.disconnect(), timeout);
  }

  // Wait for .tabs-listing to ensure product content is ready
  waitForElement(".tabs-listing", function () {
    const coinList = document.querySelector(".product-description ul.coin-list");
    const trustBadgesBlock = document.querySelector(".trust-badges-block");
    const trustBadgesSection = document.querySelector(".trust_badges-section");

    if (coinList && trustBadgesBlock) {
      // Move block into product description
      coinList.insertAdjacentElement("afterend", trustBadgesBlock);
      console.log("✅ Trust badges appended inside product description");
    } else if (!coinList && trustBadgesSection) {
      // No coin-list, just reveal the section
      trustBadgesSection.style.display = "block";
      console.log("ℹ️ No coin-list found — showing trust_badges-section");
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const navSection = document.querySelector('.shopify-section.nav-section');
    const menuItems = document.querySelectorAll('#siteNav > li');
    const megaMenus = document.querySelectorAll('#siteNav > li .megamenu');
    const dropdownItems = document.querySelectorAll('#siteNav > li .dropdown');
    let lastScrollTop = window.pageYOffset;

    window.addEventListener('scroll', function () {
        const currentScroll = window.pageYOffset;


            if (currentScroll > lastScrollTop) {
                // Scrolling down - hide mega menus
                hideMegaMenus();
            }
            // Update last scroll position
            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

    });

    function hideMegaMenus() {
        megaMenus.forEach(menu => {
            menu.style.opacity = '0';
            menu.style.visibility = 'hidden';
            menu.style.pointerEvents = 'none';
        });
         dropdownItems.forEach(menu => {
            menu.style.opacity = '0';
            menu.style.visibility = 'hidden';
            menu.style.pointerEvents = 'none';
        });
    }

    menuItems.forEach(item => {
        const megaMenu = item.querySelector('.megamenu');

        // Always show on hover regardless of scroll
        item.addEventListener('mouseenter', () => {
            if (megaMenu) {
                megaMenu.style.opacity = '1';
                megaMenu.style.visibility = 'visible';
                megaMenu.style.pointerEvents = 'auto';
            }
        });

        item.addEventListener('mouseleave', () => {
            if (megaMenu) {
                megaMenu.style.opacity = '0';
                megaMenu.style.visibility = 'hidden';
                megaMenu.style.pointerEvents = 'none';
            }
        });

         const dropdownItem = item.querySelector('.dropdown');

        // Always show on hover regardless of scroll
        item.addEventListener('mouseenter', () => {
            if (dropdownItem) {
                dropdownItem.style.opacity = '1';
                dropdownItem.style.visibility = 'visible';
                dropdownItem.style.pointerEvents = 'auto';
            }
        });

        item.addEventListener('mouseleave', () => {
            if (dropdownItem) {
                dropdownItem.style.opacity = '0';
                dropdownItem.style.visibility = 'hidden';
                dropdownItem.style.pointerEvents = 'none';
            }
        });
    });
});

